import { render, staticRenderFns } from "./razorpay.vue?vue&type=template&id=3bf81b2c&"
import script from "./razorpay.vue?vue&type=script&lang=js&"
export * from "./razorpay.vue?vue&type=script&lang=js&"
import style0 from "./razorpay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports